"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemComponent = exports.MenuItemWrapperComponent = void 0;
const mithril_1 = require("../../mithril");
const index_1 = require("../icon/index");
const theme_1 = require("../theme");
const menu_item_style_1 = require("./menu.item.style");
(0, theme_1.addStyles)(menu_item_style_1.Style);
exports.MenuItemWrapperComponent = {
    view(menu, item, selected) {
        let onclick = undefined;
        if (!item.disabled && item.action != null) {
            onclick = () => {
                menu.hide();
                item.action();
            };
        }
        return (0, mithril_1.m)('div', {
            className: `${menu_item_style_1.CSS.item} ${item.visible === false ? menu_item_style_1.CSS.hidden : ''} ${selected ? menu_item_style_1.CSS.selected : ''} ${item.disabled ? menu_item_style_1.CSS.disabled : ''}`,
            onmouseenter: () => menu.selectItem(item),
            onclick,
            id: item.id
        }, item.view);
    }
};
exports.MenuItemComponent = {
    view(text, icon) {
        return mithril_1.m.fragment({}, [].concat(icon != null ? index_1.Icon.view(icon) : null, text));
    }
};
//# sourceMappingURL=menu.item.js.map